import { whiteColor, blackColors } from 'assets/jss/material-dashboard-pro-react';

const accountFilterStyle = (theme) => ({
	account: {
		marginBottom: 0,
	},
	tableContainer: {
		position: 'relative',
		width: '100%',
	},
	accountPicker: {
		marginTop: 8,
		paddingTop: 9,
		marginBottom: 24,
		backgroundColor: whiteColor,
		'& .MuiInputBase-root': {
			paddingLeft: 17,
		},
	},
	selectedItem: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		'& p': {
			marginBottom: 0,
			lineHeight: theme.direction === 'rtl' ? 1 : 'normal',
		},
		'& svg': {
			color: blackColors[4],
			width: '24px',
			height: '24px',
			marginRight: '8px',
		},
	},
	selectedItemIcon: {
		height: 24,
		width: 24,
		marginRight: 8,
	},
	alternativeSelectWrapper: {
		marginBottom: '8px',
	},
	wrapper: {
		[theme.breakpoints.down('md')]: {
			marginBottom: '30px',
		},
	},
	billingsWrapper: {
		paddingLeft: '0 !important',
	},
	headerWrapper: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		flexWrap: 'wrap',
		marginBottom: '16px',
		marginTop: '24px',
		'& button': {
			margin: 0,
		},
	},
	heading: {
		margin: 0,
	},
});

export default accountFilterStyle;
